module.exports = __webpack_public_path__ + "static/media/crewmama_logo_plain.04d820ff.svg";